import React, { useState, useEffect } from 'react';
import { X, Plus, Minus, ShoppingBag, Check } from 'lucide-react';

export default function AddonPopup({ categorie, onClose, onConfirm, selectedAddons, setSelectedAddons }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api/addon-products?categorie=${categorie}`)
      .then(r => r.json())
      .then(data => {
        setProducts(data);
        setLoading(false);
        if (!data || data.length === 0) {
          onConfirm();
        }
      })
      .catch(() => { setLoading(false); onConfirm(); });
  }, [categorie]); // eslint-disable-line

  const toggle = (product) => {
    setSelectedAddons(prev =>
      prev.find(p => p.id === product.id)
        ? prev.filter(p => p.id !== product.id)
        : [...prev, product]
    );
  };

  const total = selectedAddons.reduce((sum, p) => sum + parseFloat(p.prix), 0);

  if (loading) return null;
  if (products.length === 0) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{background:'rgba(30,10,18,0.55)'}}>
      <div className="bg-white rounded-sm shadow-xl w-full max-w-md mx-auto overflow-hidden">
        {/* Header */}
        <div style={{background:'linear-gradient(135deg,#D8BAC3,#e8cfd6)'}} className="px-6 py-5 relative">
          <button onClick={onClose} className="absolute top-4 right-4 text-white/70 hover:text-white">
            <X size={20} />
          </button>
          <div className="flex items-center gap-2 mb-1">
            <ShoppingBag size={18} className="text-white/80" />
            <p className="text-xs tracking-widest uppercase text-white/80">Complétez votre soin</p>
          </div>
          <h2 className="text-xl font-serif text-[#3d1f2a]">Nos produits recommandés</h2>
          <p className="text-sm text-[#7a4a57] mt-1">Sélectionnez les produits à ajouter à votre réservation</p>
        </div>

        {/* Produits */}
        <div className="p-5 space-y-3 max-h-72 overflow-y-auto">
          {products.map(product => {
            const selected = !!selectedAddons.find(p => p.id === product.id);
            return (
              <button
                key={product.id}
                onClick={() => toggle(product)}
                className={`w-full flex items-center gap-4 p-3 rounded-sm border transition-all text-left ${
                  selected ? 'border-[#D8BAC3] bg-[#f9f3f5]' : 'border-border hover:border-[#D8BAC3]'
                }`}
              >
                {product.image_url ? (
                  <img src={product.image_url} alt={product.nom} className="w-14 h-14 object-cover rounded-sm flex-shrink-0" />
                ) : (
                  <div className="w-14 h-14 bg-secondary rounded-sm flex-shrink-0 flex items-center justify-center">
                    <ShoppingBag size={20} className="text-accent" />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-sm">{product.nom}</p>
                  {product.description && <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{product.description}</p>}
                  <p className="text-accent font-semibold text-sm mt-1">{parseFloat(product.prix).toFixed(2)} €</p>
                </div>
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                  selected ? 'bg-[#3d1f2a] border-[#3d1f2a]' : 'border-border'
                }`}>
                  {selected && <Check size={12} className="text-white" />}
                </div>
              </button>
            );
          })}
        </div>

        {/* Footer */}
        <div className="px-5 pb-5 pt-3 border-t border-border">
          {selectedAddons.length > 0 && (
            <p className="text-sm text-center text-muted-foreground mb-3">
              +{total.toFixed(2)} € ajouté à votre réservation
            </p>
          )}
          <button
            onClick={onConfirm}
            className="w-full py-3 text-sm font-semibold tracking-widest uppercase rounded-sm transition-colors"
            style={{background:'#3d1f2a', color:'#f0dde4'}}
          >
            {selectedAddons.length > 0 ? `Continuer avec les produits (+${total.toFixed(2)} €)` : 'Continuer sans produit'}
          </button>
        </div>
      </div>
    </div>
  );
}
